import { Indicator } from "@mantine/core";

import Icon          from "_components/atoms/icon";
import Image         from "_components/atoms/image";
import LightTooltip  from "_components/atoms/lightToolTip";
import Render        from "_components/atoms/render";
import Tooltip       from "_components/atoms/tooltip";
import ReactionsList from "_components/features/chat/userInteractions/chatReactions";

import useStyles from "./styles";

function IconsInteractions ( {
	handleToggleEmoji,
	isStreamer,
	handleModal,
	darkMode,
	isStudioPage,
	isPopOutChat,
	setOpenChatManagement,
	showPolls,
	displayEmoji,
	handleLogin,
	isLoggedIn,
	pollsCount,
	togglePolls,
	popOut,
	emotesList
} ) {
	const { classes } = useStyles ( {}, { name: "iconsInteractions" } );

	return (
		<div className = { classes.iconsInteractionCtn }
			type          = "secondary"
		>
			<div className = "flex alignItemsCenter">

				<div className = { classes.emojiContainer }
					onClick       = { () => handleToggleEmoji () }
				>

					<Icon className = { classes.svgIcon }
						name           = "emoji"
					/>

				</div>

				<Render condition = { !isStreamer }>
					<span onClick = { handleModal }
						style        = { {
							cursor: "pointer"
						} }
					>

						{darkMode ? (
							<Image className = { `${ classes.svgIconsDark } leftSpacing` }
								src             = "/icons/donation-dark.webp"
							/>
						) : (
							<Icon className = { `${ classes.svgIcons } leftSpacing` }
								name           = "donation"
							/>
						)}

					</span>

				</Render>

				<Render condition = { isStreamer && ( isStudioPage || isPopOutChat ) }>
					<Tooltip title = "Chat Management">
						<div style = { {
							marginLeft: "1rem"
						} }
						>
							<Icon className = { classes.svgIcon }
								name           = "settingsBgFilled"
								onClick        = { () => setOpenChatManagement ( true ) }
							/>
						</div>
					</Tooltip>

				</Render>

				<Render condition = { showPolls }>
					<OpenPollsIcon displayEmoji = { displayEmoji }
						handleLogin                = { handleLogin }
						isLoggedIn                 = { isLoggedIn }
						isPopOutChat               = { isPopOutChat }
						isStreamer                 = { isStreamer }
						isStudioPage               = { isStudioPage }
						pollsCount                 = { pollsCount }
						togglePolls                = { togglePolls }
					/>
				</Render>

			</div>

			<Render condition = { !isPopOutChat && isStreamer }>
				<LightTooltip // classes = { { tooltip: classes.tooltip } }
					title = "Pop-out Chat"
				>
					<div className = { `${ classes.chatPopIcon }` }>
						<Icon className = { classes.svgIcon }
							name           = "popoutChatBgFilled"
							onClick        = { popOut }
						/>
					</div>
				</LightTooltip>
			</Render>

			<Render condition = { !isStreamer }>
				<ReactionsList emotesList = { emotesList } />
			</Render>
		</div>
	);
}

function OpenPollsIcon ( { pollsCount, isStudioPage, isPopOutChat, isLoggedIn, togglePolls, handleLogin, isStreamer, displayEmoji } ) {
	const { classes } = useStyles ( { displayEmoji, isStreamer } );

	return (
		<div style = { {
			position: "relative"
		} }
		>

			{pollsCount > 0 && !isStudioPage && !isPopOutChat && (
				<Indicator
					color  = { "#e02020" }
					label  = { pollsCount }
					offset = { 5 }
					size   = { 20 }
					styles = { {
						indicator: {
							alignItems: "center"
						}
					} }
				/>
			)}

			<Icon className = { `${ classes.svgIcons } leftSpacing` }
				name           = "polls"
				onClick        = { isLoggedIn ? togglePolls : handleLogin }
			/>
		</div>
	);
}

export default IconsInteractions;
